import React, { useState } from "react";
import Counts from "./Counts/Counts";
import Appointments from "./Appointments/Appointments";
import ConsultantSummary from "./ConsultantSummary/ConsultantSummary";
import LeadsCounts from "./LeadsCounts/LeadsCounts";
import PaymentMode from "./PaymentMode/PaymentMode";
import {
  useGetReportsListQuery,
  useGetDoctorListQuery,
  useGetNewReportinExcelMutation,
} from "../../../Service/reports";
import MonthFilterSelect from "../../../Component/DigitalMarketing/MonthFilter";
import { Button, Col, Row, Card } from "react-bootstrap";
import CustomInput from "../../../Component/DigitalMarketing/CustomInput";
import DateRangePicker from "../../../Component/DigitalMarketing/Forms/DateRangePicker";

const NewReports = () => {
  const [selectedMonth, setSelectedMonth] = useState("this Month");
  const [consultantId, setConsultantId] = useState("");
  const [dateRange, setDateRange] = useState({ startDate: "", endDate: "" });
  const [status, setStatus] = useState(""); // 🆕 New state for status

  const { data, isLoading } = useGetReportsListQuery(selectedMonth, {
    refetchOnMountOrArgChange: true,
  });

  const { data: doctors, isLoading: doctorsLoading } = useGetDoctorListQuery(
    null,
    { refetchOnMountOrArgChange: true }
  );

  const [getNewReportinExcel] = useGetNewReportinExcelMutation();

  const monthOptions = [
    { value: "this Month", label: "This Month" },
    { value: "previous Month", label: "Previous Month" },
  ];

  const statusOptions = [
    { value: "scheduled", label: "scheduled" },
    { value: "reScheduled", label: "reScheduled" },
    { value: "cancel", label: "cancel" },
  ];

  const handleExport = async () => {
    try {
      const blob: any = await getNewReportinExcel({
        startDate: dateRange.startDate,
        endDate: dateRange.endDate,
        consultantId,
        status: status || undefined, // 🆕 pass only if selected
      }).unwrap();

      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "report.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      console.error("Export failed", err);
    }
  };

  return (
    <div className="p-3">
      {/* Filters Card */}
      <Card className="mb-3 shadow-sm rounded-4 border-0">
        <Card.Body>
          <Row className="align-items-center g-3">
            {/* Date Range */}
            <Col md={3}>
              <div className="mb-1 fw-600">Select Date Range</div>
              <DateRangePicker
                date={dateRange}
                key_name="date"
                handleChange={setDateRange}
              />
            </Col>

            {/* Doctor Dropdown */}
            <Col md={3}>
              <div className="mb-1 fw-600">Select Doctor</div>
              <CustomInput
                option={doctors?.data?.map((doc: any) => ({
                  value: doc.id,
                  label: `${doc.consultantName} (${doc.speciality})`,
                }))}
                type="select"
                value={consultantId}
                onChange={(e: any) => setConsultantId(e.target.value)}
                disabled={doctorsLoading}
                labelKey="label"
                valueKey="value"
              />
            </Col>

            {/* Status Dropdown */}
            <Col md={3}>
              <div className="mb-1 fw-600">Select Status</div>
              <CustomInput
                option={statusOptions}
                type="select"
                value={status}
                onChange={(e: any) => setStatus(e.target.value)}
                labelKey="label"
                valueKey="value"
              />
            </Col>

            {/* Export Button */}
            <Col md={3}>
              <div className="mb-1 fw-600">Appointment Report</div>
              <Button
                variant="primary"
                className="px-4 py-2 shadow-sm rounded-3"
                onClick={handleExport}
              >
                Export
              </Button>
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <div className="mb-1 fw-600">Select Month</div>
              <MonthFilterSelect
                value={selectedMonth}
                onChange={setSelectedMonth}
                options={monthOptions}
              />
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Summary Sections */}
      <div className="row mb-2">
        <Counts data={data} />
      </div>

      <div className="row gap-1 mt-2">
        <div className="cards col-4">
          <ConsultantSummary data={data} />
        </div>
        <div className="col-7">
          <div className="cards col-12">
            <Appointments chartData={data} />
          </div>
          <div className="d-flex gap-2">
            <div className="cards col-6 mt-2">
              <LeadsCounts data={data} />
            </div>
            <div className="cards col-6 mt-2">
              <PaymentMode data={data?.data} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewReports;
